// import { BrowserRouter, Link, NavLink, Route, Routes } from "react-router-dom";
// import { useEffect, useRef, useState } from 'react';
// import './heropage.css';
// import { HomeTest } from "../navbar/home";
// import { HomePage } from "../home/home";
// import { ProjectDemo } from "../projects/project-demo";
// import { ContactPage } from "../contact/contact";
// import { AboutPage } from "../about/about";
// import { ResponsiveSubPage } from "../about/responsive";
// import { ExpresenceSubPage } from "../about/expresence";
// import { DesignSubPage } from "../about/design";
// import { PermanceSubPage } from "../about/permance";
// import { TechPage } from "../tech/tech";
// import { All } from "../tech/all";
// import { Languages } from "../tech/language";
// import { Tools } from "../tech/tools";
// import { LoadingPage } from "./loadingPage";
// import { TemporaryDrawer } from "../test";

// export function HeroPage() {

//     const [logoImg, setLogoImg] = useState('')
//     const [resume, setResume] = useState('')

//     useEffect(() => {
//         setLogoImg('logoName.svg')
//         setResume('https://drive.google.com/file/d/1x6PnZEH6nsUyZxY8YPd-XYlnjQPyiIy_/view?usp=sharing')
//     }, [])



//     return (
//         <>
//             {/* <LoadingPage /> */}
//             <div >
//                 <BrowserRouter>
//                     <header>

//                         <div className="nav z-1 position-absolute ">
//                             <div className='navStart d-flex align-items-center justify-content-center'>
//                                 <Link to="/">
//                                     <div className="d-flex g-3">
//                                         <div className="mob-logo ">
//                                             <img src='logoName.svg' alt="Mobile Logo" />
//                                         </div>
//                                         <div className="lap-logo">
//                                             <img src="fff.svg" alt="Laptop Logo" style={{ height: '120px', width: '170px' }} />
//                                         </div>
//                                     </div>
//                                 </Link>
//                             </div>
//                             <div className='navMid'>
//                                 <div className="skills d-flex align-items-center justify-content-center">
//                                     <span className="mx-2">
//                                         <NavLink className={({ isActive }) => isActive ? "active" : ""} to="projects" style={{ fontSize: "15px" }}  > Projects </NavLink>
//                                     </span>
//                                     <span className="mx-2">
//                                         <NavLink className={({ isActive }) => isActive ? "active" : ""} to="tech" style={{ fontSize: "15px" }}  > Tech </NavLink>
//                                     </span>
//                                     <span className="mx-2">
//                                         <NavLink className={({ isActive }) => isActive ? "active" : ""} to="about" style={{ fontSize: "15px" }}   > About </NavLink>
//                                     </span>
//                                     <span className="mx-2">
//                                         <NavLink className={({ isActive }) => isActive ? "active" : ""} to="contact" style={{ fontSize: "15px" }}  > Contact </NavLink>
//                                     </span>
//                                 </div>
//                             </div>
//                             <div className='navLast d-flex align-items-center justify-content-center g-3 z-2 '>
//                                 <div className="mob-resume">
//                                     <div className="btnnav d-flex align-items-center justify-content-center mob-dis ">
//                                         <div>
//                                             <label className="switch d-flex">
//                                                 <input type="checkbox" id="check" className="switch-input d-none" />
//                                                 <div className="switch-rail">
//                                                     <span className="switch-circl"></span>
//                                                 </div>
//                                                 <span className="switch-indicator"></span>
//                                             </label>
//                                         </div>
//                                         <div className="resumebtn ms-5">
//                                             <button id="saActivenn"><a target="_blank" href={resume}>Resume</a></button>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="off-canvas z-2">
//                                     <TemporaryDrawer />
//                                 </div>

//                                 {/* update */}

//                                 {/* </nav> */}
//                             </div>



//                         </div>
//                     </header>
//                     <section style={{height:"100vh", backgroundColor:"black", overflow:"hidden"}}>
//                         <Routes>
//                             <Route path="/" element={<HomePage />} />
//                             <Route path="/projects" element={<ProjectDemo />} />
//                             <Route path="/tech" element={<TechPage />} >
//                                 <Route index element={<All />} />
//                                 <Route path="all" element={<All />}></Route>
//                                 <Route path="languages" element={<Languages />}></Route>
//                                 <Route path="tools" element={<Tools />}></Route>

//                             </Route>
//                             <Route path="/about" element={<AboutPage />} >
//                                 <Route index element={<ResponsiveSubPage />} />
//                                 <Route path="responsive" element={<ResponsiveSubPage />}></Route>
//                                 <Route path="expresence" element={<ExpresenceSubPage />}></Route>
//                                 <Route path="design" element={<DesignSubPage />}></Route>
//                                 <Route path="permance" element={<PermanceSubPage />}></Route>
//                             </Route>
//                             <Route path="/contact" element={<ContactPage />} />
//                         </Routes>
//                     </section>
//                 </BrowserRouter>
//             </div>
//         </>
//     )
// }











// import { BrowserRouter, Link, NavLink, Route, Routes, useLocation } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import "./heropage.css";
// import { HomePage } from "../home/home";
// import { ProjectDemo } from "../projects/project-demo";
// import { ContactPage } from "../contact/contact";
// import { AboutPage } from "../about/about";
// import { ResponsiveSubPage } from "../about/responsive";
// import { ExpresenceSubPage } from "../about/expresence";
// import { DesignSubPage } from "../about/design";
// import { PermanceSubPage } from "../about/permance";
// import { TechPage } from "../tech/tech";
// import { All } from "../tech/all";
// import { Languages } from "../tech/language";
// import { Tools } from "../tech/tools";
// import { TemporaryDrawer } from "../test";



// // Page Transition Animation
// const pageVariants = {
//   initial: { opacity: 0, y: 40 },
//   animate: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
//   exit: { opacity: 0, y: -40, transition: { duration: 0.4, ease: "easeIn" } },
// };

// // Navbar slide-down animation
// // const navVariant = {
// //   hidden: { opacity: 0, y: -40 },
// //   visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
// // };
// const navVariant = {
//   hidden: { opacity: 0, y: -40, visibility: "hidden" },
//   visible: {
//     opacity: 1,
//     y: 0,
//     visibility: "visible",
//     transition: { duration: 0.8, ease: "easeOut" },
//   },
// };

// export function HeroPage() {
//   const [logoImg, setLogoImg] = useState("");
//   const [resume, setResume] = useState("");

//   useEffect(() => {
//     setLogoImg("logoName.svg");
//     setResume("https://drive.google.com/file/d/1x6PnZEH6nsUyZxY8YPd-XYlnjQPyiIy_/view?usp=sharing");
//   }, []);

//   return (
//     <BrowserRouter>
//       <header>
//         {/* === Animated Navbar === */}
//         <motion.div
//           className="nav z-1 position-absolute"
//           variants={navVariant}
//           initial="hidden"
//           animate="visible"
//         >
//           <div className="navStart d-flex align-items-center justify-content-center">
//             <Link to="/">
//               <div className="d-flex g-3">
//                 <div className="mob-logo">
//                   <img src={logoImg} alt="Mobile Logo" />
//                 </div>
//                 <div className="lap-logo">
//                   <img src="fff.svg" alt="Laptop Logo" style={{ height: "120px", width: "170px" }} />
//                 </div>
//               </div>
//             </Link>
//           </div>

//           <div className="navMid">
//             <div className="skills d-flex align-items-center justify-content-center">
//               {["projects", "tech", "about", "contact"].map((item, i) => (
//                 <motion.span
//                   key={item}
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.5, delay: 0.5 + i * 0.1 }}
//                   className="mx-2"
//                 >
//                   <NavLink
//                     to={item}
//                     className={({ isActive }) => (isActive ? "active" : "")}
//                     style={{ fontSize: "15px" }}
//                   >
//                     {item.charAt(0).toUpperCase() + item.slice(1)}
//                   </NavLink>
//                 </motion.span>
//               ))}
//             </div>
//           </div>

//           <div className="navLast d-flex align-items-center justify-content-center g-3 z-2">
//             <div className="mob-resume">
//               <div className="btnnav d-flex align-items-center justify-content-center mob-dis">
//                 <motion.div
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.5, delay: 0.9 }}
//                 >
//                   <label className="switch d-flex">
//                     <input type="checkbox" id="check" className="switch-input d-none" />
//                     <div className="switch-rail">
//                       <span className="switch-circl"></span>
//                     </div>
//                     <span className="switch-indicator"></span>
//                   </label>
//                 </motion.div>

//                 <motion.div
//                   className="resumebtn ms-5"
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.5, delay: 1.1 }}
//                 >
//                   <button id="saActivenn">
//                     <a target="_blank" rel="noreferrer" href={resume}>
//                       Resume
//                     </a>
//                   </button>
//                 </motion.div>
//               </div>
//             </div>

//             <div className="off-canvas z-2">
//               <TemporaryDrawer />
//             </div>
//           </div>
//         </motion.div>
//       </header>

//       {/* === Animated Page Section === */}
//       <AnimatedRoutes />
//     </BrowserRouter>
//   );
// }

// // === AnimatePresence Wrapper for Route Transitions ===
// function AnimatedRoutes() {
//   const location = useLocation();

//   return (
//     <section style={{ height: "100vh", backgroundColor: "black", overflow: "hidden" }}>
//       <AnimatePresence mode="wait">
//         <Routes location={location} key={location.pathname}>
//           <Route
//             path="/"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <HomePage />
//               </motion.div>
//             }
//           />
//           <Route
//             path="/projects"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <ProjectDemo />
//               </motion.div>
//             }
//           />
//           <Route
//             path="/tech"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <TechPage />
//               </motion.div>
//             }
//           >
//             <Route index element={<All />} />
//             <Route path="all" element={<All />} />
//             <Route path="languages" element={<Languages />} />
//             <Route path="tools" element={<Tools />} />
//           </Route>
//           <Route
//             path="/about"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <AboutPage />
//               </motion.div>
//             }
//           >
//             <Route index element={<ResponsiveSubPage />} />
//             <Route path="responsive" element={<ResponsiveSubPage />} />
//             <Route path="expresence" element={<ExpresenceSubPage />} />
//             <Route path="design" element={<DesignSubPage />} />
//             <Route path="permance" element={<PermanceSubPage />} />
//           </Route>
//           <Route
//             path="/contact"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <ContactPage />
//               </motion.div>
//             }
//           />
//         </Routes>
//       </AnimatePresence>
//     </section>
//   );
// }








// import { BrowserRouter, Link, NavLink, Route, Routes, useLocation } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import "./heropage.css";
// import { HomePage } from "../home/home";
// import { ProjectDemo } from "../projects/project-demo";
// import { ContactPage } from "../contact/contact";
// import { AboutPage } from "../about/about";
// import { ResponsiveSubPage } from "../about/responsive";
// import { ExpresenceSubPage } from "../about/expresence";
// import { DesignSubPage } from "../about/design";
// import { PermanceSubPage } from "../about/permance";
// import { TechPage } from "../tech/tech";
// import { All } from "../tech/all";
// import { Languages } from "../tech/language";
// import { Tools } from "../tech/tools";
// import { TemporaryDrawer } from "../test";

// // === Page Transition Animation ===
// const pageVariants = {
//   initial: { opacity: 0, y: 40 },
//   animate: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
//   exit: { opacity: 0, y: -40, transition: { duration: 0.4, ease: "easeIn" } },
// };

// // === Navbar slide-down animation ===
// const navVariant = {
//   hidden: { opacity: 0, y: -40 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.8, ease: "easeOut" },
//   },
// };

// export function HeroPage() {
//   const [logoImg, setLogoImg] = useState("");
//   const [resume, setResume] = useState("");
//   // navReady becomes true when navbar animation completes
//   const [navReady, setNavReady] = useState(false);

//   useEffect(() => {
//     setLogoImg("logoName.svg");
//     setResume("https://drive.google.com/file/d/1x6PnZEH6nsUyZxY8YPd-XYlnjQPyiIy_/view?usp=sharing");
//   }, []);

//   return (
//     <BrowserRouter>
//       <header>
//         {/* Animated Navbar.
//             We toggle navReady via onAnimationComplete to enable hover/clicks only after animation. */}
//         <motion.div
//           className={`nav z-1 position-absolute ${navReady ? "nav-ready" : "nav-not-ready"}`}
//           variants={navVariant}
//           initial="hidden"
//           animate="visible"
//           onAnimationComplete={() => setNavReady(true)}
//         >
//           <div className="navStart d-flex align-items-center justify-content-center">
//             <Link to="/">
//               <div className="d-flex g-3">
//                 <div className="mob-logo">
//                   <img src={logoImg} alt="Mobile Logo" />
//                 </div>
//                 <div className="lap-logo">
//                   <img src="fff.svg" alt="Laptop Logo" style={{ height: "120px", width: "170px" }} />
//                 </div>
//               </div>
//             </Link>
//           </div>

//           <div className="navMid">
//             <div className="skills d-flex align-items-center justify-content-center">
//               {["projects", "tech", "about", "contact"].map((item, i) => (
//                 <motion.span
//                   key={item}
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.5, delay: 0.5 + i * 0.1 }}
//                   className="mx-2"
//                 >
//                   <NavLink
//                     to={item}
//                     className={({ isActive }) => (isActive ? "active" : "")}
//                     style={{ fontSize: "15px" }}
//                   >
//                     {item.charAt(0).toUpperCase() + item.slice(1)}
//                   </NavLink>
//                 </motion.span>
//               ))}
//             </div>
//           </div>

//           <div className="navLast d-flex align-items-center justify-content-center g-3 z-2">
//             <div className="mob-resume">
//               <div className="btnnav d-flex align-items-center justify-content-center mob-dis">
//                 <motion.div
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.5, delay: 0.9 }}
//                 >
//                   <label className="switch d-flex">
//                     <input type="checkbox" id="check" className="switch-input d-none" />
//                     <div className="switch-rail">
//                       <span className="switch-circl"></span>
//                     </div>
//                     <span className="switch-indicator"></span>
//                   </label>
//                 </motion.div>

//                 <motion.div
//                   className="resumebtn ms-5"
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.5, delay: 1.1 }}
//                 >
//                   <button id="saActivenn">
//                     <a target="_blank" rel="noreferrer" href={resume}>
//                       Resume
//                     </a>
//                   </button>
//                 </motion.div>
//               </div>
//             </div>

//             <div className="off-canvas z-2">
//               <TemporaryDrawer />
//             </div>
//           </div>
//         </motion.div>
//       </header>

//       {/* AnimatedRoutes uses useLocation so it must be inside BrowserRouter */}
//       <AnimatedRoutes />
//     </BrowserRouter>
//   );
// }

// // === AnimatePresence Wrapper for Route Transitions ===
// function AnimatedRoutes() {
//   const location = useLocation();

//   return (
//     <section style={{ height: "100vh", backgroundColor: "black", overflow: "hidden" }}>
//       <AnimatePresence mode="wait">
//         <Routes location={location} key={location.pathname}>
//           <Route
//             path="/"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <HomePage />
//               </motion.div>
//             }
//           />
//           <Route
//             path="/projects"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <ProjectDemo />
//               </motion.div>
//             }
//           />
//           <Route
//             path="/tech"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <TechPage />
//               </motion.div>
//             }
//           >
//             <Route index element={<All />} />
//             <Route path="all" element={<All />} />
//             <Route path="languages" element={<Languages />} />
//             <Route path="tools" element={<Tools />} />
//           </Route>
//           <Route
//             path="/about"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <AboutPage />
//               </motion.div>
//             }
//           >
//             <Route index element={<ResponsiveSubPage />} />
//             <Route path="responsive" element={<ResponsiveSubPage />} />
//             <Route path="expresence" element={<ExpresenceSubPage />} />
//             <Route path="design" element={<DesignSubPage />} />
//             <Route path="permance" element={<PermanceSubPage />} />
//           </Route>
//           <Route
//             path="/contact"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <ContactPage />
//               </motion.div>
//             }
//           />
//         </Routes>
//       </AnimatePresence>
//     </section>
//   );
// }



//----------------------------------------------------

// import { BrowserRouter, Link, NavLink, Route, Routes, useLocation } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import "./heropage.css";
// import { HomePage } from "../home/home";
// import { ProjectDemo } from "../projects/project-demo";
// import { ContactPage } from "../contact/contact";
// import { AboutPage } from "../about/about";
// import { ResponsiveSubPage } from "../about/responsive";
// import { ExpresenceSubPage } from "../about/expresence";
// import { DesignSubPage } from "../about/design";
// import { PermanceSubPage } from "../about/permance";
// import { TechPage } from "../tech/tech";
// import { All } from "../tech/all";
// import { Languages } from "../tech/language";
// import { Tools } from "../tech/tools";
// import { TemporaryDrawer } from "../test";
// import { LoadingPage } from "./loadingPage";

// // Page transition animation
// const pageVariants = {
//   initial: { opacity: 0, y: 40 },
//   animate: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
//   exit: { opacity: 0, y: -40, transition: { duration: 0.4, ease: "easeIn" } },
// };

// // Navbar slide-down animation
// const navVariant = {
//   hidden: { opacity: 0, y: -40 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
// };

// export function HeroPage() {
//   const [logoImg, setLogoImg] = useState("");
//   const [resume, setResume] = useState("");
//   const [navReady, setNavReady] = useState(false); // Track if nav animation finished

//   useEffect(() => {
//     setLogoImg("logoName.svg");
//     setResume(
//       "https://drive.google.com/file/d/1x6PnZEH6nsUyZxY8YPd-XYlnjQPyiIy_/view?usp=sharing"
//     );
//   }, []);

//   return (
//     <>
//       <LoadingPage />
//       <div>
//         <BrowserRouter>
//           <header>
//             {/* Animated Navbar */}
//             <motion.div
//               className={`nav z-1 position-absolute ${navReady ? "nav-ready" : "nav-not-ready"}`}
//               variants={navVariant}
//               initial="hidden"
//               animate="visible"
//               onAnimationComplete={() => setNavReady(true)}
//             >
//               <div className="navStart d-flex align-items-center justify-content-center">
//                 <Link to="/">
//                   <div className="d-flex g-3">
//                     <div className="mob-logo">
//                       <img src={logoImg} alt="Mobile Logo" />
//                     </div>
//                     <div className="lap-logo">
//                       <img
//                         src="fff.svg"
//                         alt="Laptop Logo"
//                         style={{ height: "120px", width: "170px" }}
//                       />
//                     </div>
//                   </div>
//                 </Link>
//               </div>
//               <div className="navMid">
//                 {/* Animate the whole midNav together */}
//                 <motion.div
//                   className="skills d-flex align-items-center justify-content-center"
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.8, ease: "easeOut" }}
//                 >
//                   {["projects", "tech", "about", "contact"].map((item) => (
//                     <NavLink
//                       key={item}
//                       to={item}
//                       className={({ isActive }) => (isActive ? "active mx-2" : "mx-2")}
//                       style={{ fontSize: "15px" }}
//                     >
//                       {item.charAt(0).toUpperCase() + item.slice(1)}
//                     </NavLink>
//                   ))}
//                 </motion.div>
//               </div>


//               <div className="navLast d-flex align-items-center justify-content-center g-3 z-2">
//                 <div className="mob-resume">
//                   <div className="btnnav d-flex align-items-center justify-content-center mob-dis">
//                     <motion.div
//                       initial={{ opacity: 0, y: 20 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.5, delay: 0.9 }}
//                     >
//                       <label className="switch d-flex">
//                         <input type="checkbox" id="check" className="switch-input d-none" />
//                         <div className="switch-rail">
//                           <span className="switch-circl"></span>
//                         </div>
//                         <span className="switch-indicator"></span>
//                       </label>
//                     </motion.div>

//                     <motion.div
//                       className="resumebtn ms-5"
//                       initial={{ opacity: 0, y: 20 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.5, delay: 1.1 }}
//                     >
//                       <button id="saActivenn">
//                         <a target="_blank" rel="noreferrer" href={resume}>
//                           Resume
//                         </a>
//                       </button>
//                     </motion.div>
//                   </div>
//                 </div>

//                 <div className="off-canvas z-2">
//                   <TemporaryDrawer />
//                 </div>
//               </div>
//             </motion.div>
//           </header>

//           {/* Animated Page Section */}
//           <AnimatedRoutes />
//         </BrowserRouter>
//       </div>
//     </>
//   );
// }

// function AnimatedRoutes() {
//   const location = useLocation();

//   return (
//     <section style={{ height: "100vh", backgroundColor: "black", overflow: "hidden" }}>
//       <AnimatePresence mode="wait">
//         <Routes location={location} key={location.pathname}>
//           <Route
//             path="/"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <HomePage />
//               </motion.div>
//             }
//           />
//           <Route
//             path="/projects"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <ProjectDemo />
//               </motion.div>
//             }
//           />
//           <Route
//             path="/tech"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <TechPage />
//               </motion.div>
//             }
//           >
//             <Route index element={<All />} />
//             <Route path="all" element={<All />} />
//             <Route path="languages" element={<Languages />} />
//             <Route path="tools" element={<Tools />} />
//           </Route>
//           <Route
//             path="/about"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <AboutPage />
//               </motion.div>
//             }
//           >
//             <Route index element={<ResponsiveSubPage />} />
//             <Route path="responsive" element={<ResponsiveSubPage />} />
//             <Route path="expresence" element={<ExpresenceSubPage />} />
//             <Route path="design" element={<DesignSubPage />} />
//             <Route path="permance" element={<PermanceSubPage />} />
//           </Route>
//           <Route
//             path="/contact"
//             element={
//               <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
//                 <ContactPage />
//               </motion.div>
//             }
//           />
//         </Routes>
//       </AnimatePresence>
//     </section>
//   );
// }

///----------------------------------------------------------


import { BrowserRouter, Link, NavLink, Route, Routes, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./heropage.css";
import { HomePage } from "../home/home";
import { ProjectDemo } from "../projects/project-demo";
import { ContactPage } from "../contact/contact";
import { AboutPage } from "../about/about";
import { ResponsiveSubPage } from "../about/responsive";
import { ExpresenceSubPage } from "../about/expresence";
import { DesignSubPage } from "../about/design";
import { PermanceSubPage } from "../about/permance";
import { TechPage } from "../tech/tech";
import { All } from "../tech/all";
import { Languages } from "../tech/language";
import { Tools } from "../tech/tools";
import { TemporaryDrawer } from "../test";
import { LoadingPage } from "./loadingPage";

// Page transition animation
const pageVariants = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  exit: { opacity: 0, y: -40, transition: { duration: 0.4, ease: "easeIn" } },
};

// Navbar slide-down animation
const navVariant = {
  hidden: { opacity: 0, y: -40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

export function HeroPage() {
  const [logoImg, setLogoImg] = useState("");
  const [resume, setResume] = useState("");
  const [navReady, setNavReady] = useState(false);
  const [loadingDone, setLoadingDone] = useState(false); // 👈 Track loading completion

  useEffect(() => {
    setLogoImg("logoName.svg");
    setResume(
      "https://drive.google.com/file/d/1x6PnZEH6nsUyZxY8YPd-XYlnjQPyiIy_/view?usp=sharing"
    );

    // ⏳ Simulate loading time (8 seconds total)
    const timer = setTimeout(() => {
      setLoadingDone(true);
    }, 4200);

    return () => clearTimeout(timer);
  }, []);

  // While loading, show only LoadingPage
  if (!loadingDone) {
    return <LoadingPage />;
  }

  // After loading completes, render full motion setup
  return (
    <div>
      <BrowserRouter>
        <header>
          {/* Animated Navbar */}
          <motion.div
            className={`nav z-1 position-absolute ${navReady ? "nav-ready" : "nav-not-ready"}`}
            variants={navVariant}
            initial="hidden"
            animate="visible"
            onAnimationComplete={() => setNavReady(true)}
          >
            <div className="navStart d-flex align-items-center justify-content-center">
              <Link to="/">
                <div className="d-flex g-3">
                  <div className="mob-logo">
                    <img src={logoImg} alt="Mobile Logo" />
                  </div>
                  <div className="lap-logo">
                    <img
                      src="fff.svg"
                      alt="Laptop Logo"
                      style={{ height: "120px", width: "170px" }}
                    />
                  </div>
                </div>
              </Link>
            </div>

            <div className="navMid">
              <motion.div
                className="skills d-flex align-items-center justify-content-center"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
              >
                {["projects", "tech", "about", "contact"].map((item) => (
                  <NavLink
                    key={item}
                    to={item}
                    className={({ isActive }) => (isActive ? "active mx-2" : "mx-2")}
                    style={{ fontSize: "15px" }}
                  >
                    {item.charAt(0).toUpperCase() + item.slice(1)}
                  </NavLink>
                ))}
              </motion.div>
            </div>

            <div className="navLast d-flex align-items-center justify-content-center g-3 z-2">
              <div className="mob-resume">
                <div className="btnnav d-flex align-items-center justify-content-center mob-dis">
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.9 }}
                  >
                    <label className="switch d-flex">
                      <input type="checkbox" id="check" className="switch-input d-none" />
                      <div className="switch-rail">
                        <span className="switch-circl"></span>
                      </div>
                      <span className="switch-indicator"></span>
                    </label>
                  </motion.div>

                  <motion.div
                    className="resumebtn ms-5"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 1.1 }}
                  >
                    <button id="saActivenn">
                      <a target="_blank" rel="noreferrer" href={resume}>
                        Resume
                      </a>
                    </button>
                  </motion.div>
                </div>
              </div>

              <div className="off-canvas z-2">
                <TemporaryDrawer />
              </div>
            </div>
          </motion.div>
        </header>

        {/* Animated Page Section */}
        <AnimatedRoutes />
      </BrowserRouter>
    </div>
  );
}

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <section style={{ height: "100vh", backgroundColor: "black", overflow: "hidden" }}>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
                <HomePage />
              </motion.div>
            }
          />
          <Route
            path="/projects"
            element={
              <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
                <ProjectDemo />
              </motion.div>
            }
          />
          <Route
            path="/tech"
            element={
              <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
                <TechPage />
              </motion.div>
            }
          >
            <Route index element={<All />} />
            <Route path="all" element={<All />} />
            <Route path="languages" element={<Languages />} />
            <Route path="tools" element={<Tools />} />
          </Route>
          <Route
            path="/about"
            element={
              <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
                <AboutPage />
              </motion.div>
            }
          >
            <Route index element={<ResponsiveSubPage />} />
            <Route path="responsive" element={<ResponsiveSubPage />} />
            <Route path="expresence" element={<ExpresenceSubPage />} />
            <Route path="design" element={<DesignSubPage />} />
            <Route path="permance" element={<PermanceSubPage />} />
          </Route>
          <Route
            path="/contact"
            element={
              <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
                <ContactPage />
              </motion.div>
            }
          />
        </Routes>
      </AnimatePresence>
    </section>
  );
}
